var hasOwn = Object.hasOwnProperty;
/**
 * @description 检测一个对象是否有指定的自身属性
 * @param {Object} object
 * @return {Boolean}
 */
export function hasOwnProperty(object, porperty) {
  return hasOwn.call(object, porperty);
}